import { Flex, Spinner } from '@chakra-ui/react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth.js'

/**
 * Gate for the private Learn app. Learn is a closed product: every learning
 * route lives behind authentication (07-learn-redesign-brief §3bis, decision 4,
 * revised 2026-06-01). A visitor with no session never sees course content —
 * they are sent to `/login` with a `returnTo` so they land back where they
 * aimed once authenticated. The public catalog / previews live in the blog.
 */
export function RequireAuth() {
  const { session, loading } = useAuth()
  const location = useLocation()

  if (loading) {
    return (
      <Flex justify="center" align="center" minH="100vh">
        <Spinner color="acp.blue" size="lg" />
      </Flex>
    )
  }

  if (!session) {
    const returnTo = encodeURIComponent(location.pathname + location.search)
    return <Navigate to={`/login?returnTo=${returnTo}`} replace />
  }

  return <Outlet />
}
